import React from "react";

const LearningOptions = (props) => {
  const options = [
    {
      text: 'Renseignements généraux',
      handler: props.actionProvider.handleGeneralQuestions,
      id: 1,
    },
    {
      text: 'Fonctionnalité ',
      handler: props.actionProvider.handleFunctionalityQuestions,
      id: 2 },
    {
      text: 'Paiements et remboursements',
      handler: props.actionProvider.handlePaymentsRefunds,
      id: 3
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.id}>
    <input
      type="radio"
      className='learning-option-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />

      <span>{option.text}</span>
      </label>
    
  ));

  return <div className='learning-options-container'>{optionsMarkup}</div>;
};

export default LearningOptions;